import React, { useCallback, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { Form } from '@unform/web';

import { mutate as mutateGlobal } from 'swr';
import api from '../../services/api';
import { useFetchCategories } from './hooks/useFetchCategories';
import { useFetchSearchCategories } from './hooks/useFetchSearchCategories';
import { useToast } from '../../hooks/toast';

import ButtonPrimaryGree from '../../components/ButtonPrimaryGreen';
import { InputSearch } from '../../components/Form';
import NavbarMenu from '../../components/NavbarMenu';
import ContainerBox from '../../components/ContainerBox';
import ButtonGroupbox from '../../components/ContainerBox/ButtonGroupbox';
import Table from '../../components/Table';
import Loading from '../../components/Loading';
import Pagination from '../../components/Pagination';

import { Container, TotalItems } from './styles';

const Categories = () => {
  const formRef = useRef(null);

  const [page, setPage] = useState(1);
  const [url, setUrl] = useState('/categories?page=1');
  const [showCategories, setShowCategories] = useState(true);

  const { dataList: categories, loading, totalItems } = useFetchCategories(
    `/categories?page=${page}`
  );

  const {
    dataList: searchCategories,
    loading: loadingSearch,
  } = useFetchSearchCategories(url);

  const { addToast } = useToast();

  const head = {
    id: 'ID',
    description: 'Descrição',
    type: 'Tipo de Categoria',
  };

  const handleCategoriesDelete = useCallback(
    async (id) => {
      try {
        if (
          window.confirm(`Tem Certeza que realmente deseja excluir o registro?`)
        ) {
          await api.delete(`/categories/${id}`);

          mutateGlobal(`/categories?page=${page}`);
          mutateGlobal(url);

          addToast({
            type: 'success',
            title: 'Cadastro Excluido com Sucesso',
          });
        } else {
          return;
        }
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao excluir verifique.',
        });
      }
    },
    [addToast, page, url]
  );

  const handleSubmit = useCallback(() => {
    const input = formRef.current.getFieldValue('inputcategory');

    if (!input) {
      setUrl('/categories?page=1');
      setPage(1);
      setShowCategories(true);

      return;
    }

    setUrl(`/categorysearch?search=${input}`);
    setShowCategories(false);
    formRef.current.reset();
  }, []);

  const handleEnter = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleSubmit();
      }
    },
    [handleSubmit]
  );

  return (
    <Container>
      <NavbarMenu />
      <ContainerBox title="Categorias ">
        <ButtonGroupbox>
          <Link to="/categories/newedit">
            <ButtonPrimaryGree icon={FiPlus}>Adicionar</ButtonPrimaryGree>
          </Link>

          <Form ref={formRef} onSubmit={() => {}}>
            <InputSearch
              id="inputcategory"
              name="inputcategory"
              autoComplete="off"
              onKeyDown={(e) => handleEnter(e)}
              handleClick={handleSubmit}
            />
          </Form>
        </ButtonGroupbox>

        {showCategories && loading && <Loading />}

        {showCategories && !loading && categories && (
          <>
            <Table
              head={head}
              data={categories}
              handleDelete={handleCategoriesDelete}
              pathname="/categories/newedit"
            />
            {totalItems && (
              <TotalItems>
                <span>
                  Total de registro(s): <b>{totalItems}</b>
                </span>
              </TotalItems>
            )}
            {totalItems > 20 && (
              <Pagination
                setPage={setPage}
                currentPage={page}
                totalItems={totalItems}
              />
            )}
          </>
        )}

        {!showCategories && loadingSearch && <Loading />}

        {!showCategories && !loadingSearch && searchCategories && (
          <Table
            head={head}
            data={searchCategories}
            handleDelete={handleCategoriesDelete}
            pathname="/categories/newedit"
          />
        )}
      </ContainerBox>
    </Container>
  );
};

export default Categories;
